import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AdminSidebar.styles';
import logo from '../../assets/logo_white.png';

import Image from '../../components/common/image/Image';
import Icon from '../../components/common/icon/Icon';
import SvgIcon from '../../components/common/svgicon/SvgIcon';

export class AdminSidebar extends Component {
  navLinks = [
    {
      to: '/admin/status',
      icon: <Icon value="construction" styles={styles.itemIcon} />,
      text: I18n.t('admin.status')
    },
    {
      to: '/admin',
      icon: <SvgIcon value="globe-white" styles={styles.itemSvgIcon} />,
      text: I18n.t('admin.admin')
    },
    {
      to: '/admin/users',
      icon: <Icon value="users" styles={styles.itemIcon} />,
      text: I18n.t('admin.users')
    }
  ];
  handleClick = (item,e) =>{
    if(item.to==='/admin/alerts'){
      e.stopPropagation();
      e.preventDefault();
    }
    return e;
  };
  render() {
    
    return (
      <nav className={css(styles.sidebar)}>
        <div className={css(styles.logo)}>
          <Image src={logo} alt="logo" />
        </div>
        <div className={css(styles.list)}>
        
          {this.navLinks.map(item => {
            let s = [styles.item];
            if(item.to === '/admin/alerts'){
              s.push(styles.disabledItem);
            }
            return (
            <NavLink
              key={item.text}
              exact
              to={item.to}
              className={css(...s)}
              activeClassName={css(styles.activeItem)}
              onClick={this.handleClick.bind(this,item)}
            >
              {item.icon}
              <span className={css(styles.itemText)}>{item.text}</span>
            </NavLink>
          )})}
        </div>
      </nav>
    );
  }
}

export default AdminSidebar;



// WEBPACK FOOTER //
// ./src/containers/adminsidebar/AdminSidebar.js